// test675
(675 && 0);
